/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { Menu } from '../models/menu';
import { Customer } from '../models/customer';
import { ContactInfo } from '../models/contact';
import { Social } from '../models/social';
import { MenuActionTypes } from '@uxdf/direct-shared-lib';

export enum ActionsTypes {
  SetCustomerConfig = '[CUSTOMER] Set customer config',
  ResetCustomerConfig = '[CUSTOMER] Reset customer config to initial state',
  InitContactConfig = '[Contact] Init contact config',
  SetContactConfig = '[Contact] Set contact config',
  InitSocialLinksConfig = '[SOCIAL] Init social links config',
  SetSocialLinksConfig = '[SOCIAL] Set social links config',
  InitSsoLinks = '[SSO] init sso links',
  SetSsoLinks = '[SSO] set sso links',
  AvailabilityCheck = '[AVAILABILITY] check',
  AvailabilityChecked = '[AVAILABILITY] checked',
  SetupPermissions = '[PERMISSION] setup by modular config',
  SetupPermissionsSuccess = '[PERMISSION] setup by modular config - success',
  SetupPreferredLang = '[LANGUAGE] setup preferred lang by customer config',
  SetupPreferredLangSuccess = '[LANGUAGE] setup preferred lang by customer config - success'
}

export class SetCustomerConfig implements Action {
  readonly type = ActionsTypes.SetCustomerConfig;
  constructor(public payload: { customerConfig: Customer }) {}
}

export class ResetCustomerConfig implements Action {
  readonly type = ActionsTypes.ResetCustomerConfig;
  constructor() {}
}

export class InitGuestMenuList implements Action {
  readonly type = MenuActionTypes.InitGuestMenuList;
  constructor(public payload: { storeCode: string }) {}
}

export class SetMenuList implements Action {
  readonly type = MenuActionTypes.SetMenuList;
  constructor(public payload: { menuList: Menu }) {}
}

export class InitContactConfig implements Action {
  readonly type = ActionsTypes.InitContactConfig;
  constructor(public payload: any) {}
}

export class SetContactConfig implements Action {
  readonly type = ActionsTypes.SetContactConfig;
  constructor(public payload: { contactInfo: ContactInfo }) {}
}

export class InitSocialLinksConfig implements Action {
  readonly type = ActionsTypes.InitSocialLinksConfig;
  constructor(public payload: any) {}
}

export class SetSocialLinksConfig implements Action {
  readonly type = ActionsTypes.SetSocialLinksConfig;
  constructor(public payload: { socialLinks: Social }) {}
}

export class InitSsoLinks implements Action {
  readonly type = ActionsTypes.InitSsoLinks;
  constructor(public payload: { storeCode: any; userType: any }) {}
}

export class SetSsoLinks implements Action {
  readonly type = ActionsTypes.SetSsoLinks;
  constructor(public payload: any) {}
}

export class AvailabilityCheck implements Action {
  readonly type = ActionsTypes.AvailabilityCheck;
  constructor() {}
}

export class AvailabilityChecked implements Action {
  readonly type = ActionsTypes.AvailabilityChecked;
  constructor(public payload: any) {}
}

export class SetupPermissions implements Action {
  readonly type = ActionsTypes.SetupPermissions;
  constructor(public payload: any) {}
}

export class SetupPermissionsSuccess implements Action {
  readonly type = ActionsTypes.SetupPermissionsSuccess;
  constructor(public payload: any) {}
}

export class SetupPreferredLang implements Action {
  readonly type = ActionsTypes.SetupPreferredLang;
  constructor(public payload: { customerConfig: Customer }) {}
}

export class SetupPreferredLangSuccess implements Action {
  readonly type = ActionsTypes.SetupPreferredLangSuccess;
  constructor(public payload: Customer) {}
}

export type Actions =
  | SetCustomerConfig
  | ResetCustomerConfig
  | InitGuestMenuList
  | SetMenuList
  | InitContactConfig
  | SetContactConfig
  | InitSocialLinksConfig
  | SetSocialLinksConfig
  | InitSsoLinks
  | SetSsoLinks
  | AvailabilityCheck
  | AvailabilityChecked
  | SetupPermissions
  | SetupPermissionsSuccess
  | SetupPreferredLang
  | SetupPreferredLangSuccess;
